<div class="product-swiper" *ngIf="showSwiper">
  <div  *ngIf="dataArray?.length>1 && showPrev" (click)="prev()"  class="prev" >
    <img src="/assets/icon/arrow-left.svg" alt="arrow left">

  </div>
  <div *ngIf=" showNext" class="next" (click)="next()">
    <img src="/assets/icon/arrow-right.svg" alt="arrow right" >
  </div>
  <swiper  *ngIf="dataArray?.length===0 || !dataArray" [config]="config"  >
    <ng-template *ngFor="let item of  [1,2,3,4,5];let i = index" swiperSlide>
      <ion-skeleton-text style="aspect-ratio: 1/1;" animated="true"></ion-skeleton-text>
    </ng-template>
  </swiper>
  <swiper *ngIf="dataArray?.length !==0 && reloadSwiper" [config]="isMobile?configMobile:config" (init)="swiperInit($event)" (activeIndexChange)="activeIndexChange($event)" (reachEnd)="reachEnd()">
    <ng-template *ngFor="let item of  dataArray;let i = index" swiperSlide>
      <app-product-card [data]="item"></app-product-card>
    </ng-template>
  </swiper>
</div>
